import { descriptors } from "../packages/descriptors.js";
import { coreEngine } from "../packages/engine.js";
import { events } from "../packages/events.js";
import { Entity } from "./entity.js";

class Action extends Entity {
  execute = [];
  namespace = "action";
  triggers = [];

  init(cNode) {
    super.init(cNode);
    for (const trigger of cNode.props.triggers) {
      events.addAction(trigger, this.executeAction.bind(this, cNode));
    }
  }

  executeAction(cNode, event) {
    const actionEvent = event.clone();
    actionEvent.time = event.time + cNode.props.delay;
    
    // This uses the new logging method - passing cNode as first parameter
    this.log(cNode, `Executing action with ${cNode.props.execute.length} tasks`, {
      delay: cNode.props.delay,
      event: event.name
    });

    for (const config of cNode.props.execute) {
      const componentDescriptor = descriptors.get(config.namespace);

      if (componentDescriptor) {
        coreEngine.create(config);
        continue;
      }

      const methodDescriptor = descriptors.getMethodDescriptor(config.namespace);
      const namespaceSegments = config.namespace.split(":");
      const componentNamespace = namespaceSegments.slice(0, -1).join(":");
      const methodName = namespaceSegments.at(-1);

      if (!methodDescriptor) {
        // Using new logging method for warnings - passing cNode as first parameter
        this.warn(
          cNode,
          `Component [${componentNamespace}] with uid [${config.uid}] doesn't have a method called ${methodName}`
        );
        continue;
      }

      coreEngine.update(
        {
          uid: config.uid,
          key: methodName,
          value: config,
        },
        actionEvent,
      );
    }
  }

  destroy(cNode) {
    this.log(cNode, "Destroying action component", { triggers: this.triggers });
    
    for (const trigger of this.triggers) {
      events.removeAction(trigger, this.executeAction);
    }
  }
}

const action = new Action();

export { Action, action };